const seeMoreItem = document.getElementById('js-description-see-more')
const fontSize = parseInt(window.getComputedStyle(seeMoreItem).fontSize)

if (window.innerWidth > 480) {
  if (seeMoreItem.clientHeight > fontSize * 1.5 * 7.4) {
    seeMoreItem.setAttribute('aria-disabled', 'true')
  }
} else {
  if (seeMoreItem.clientHeight > fontSize * 1.5 * 8) {
    seeMoreItem.setAttribute('aria-disabled', 'true')
  }
}

seeMoreItem.addEventListener('click', () => {
  seeMoreItem.setAttribute('aria-disabled', 'false')
})
